function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21 .6a6.4 6.4 0 00-6.4 5.8H3.5a3 3 0 00-3 3v15.1a3 3 0 003 3h21a3 3 0 003-3V9.3l-.2-.9.1-1.4A6.4 6.4 0 0021 .6zm3.5 25.6h-21a1.7 1.7 0 01-1.7-1.7V13.7l12 5.5a.6.6 0 00.4 0l12-5.5v10.8a1.7 1.7 0 01-1.7 1.8zm1.8-13.7L14 18 1.8 12.5V9.3a1.7 1.7 0 011.7-1.7h11.1a6.4 6.4 0 0011.7 3v1.9zm-.3-4a5.2 5.2 0 11-10-3 5.2 5.2 0 0110 3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23 5l-2.8 2.7-1.1-1.1a.6.6 0 00-.8.8L19.8 9a.6.6 0 00.8 0l3.1-3.1A.6.6 0 1023 5z"
});

function SvgIconEmailVerify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailVerify);
export default __webpack_public_path__ + "static/media/icon-email-verify.fcd70d1c.svg";
export { ForwardRef as ReactComponent };